import React from 'react';
import { SignUpForm } from '../../components/auth';
import { AuthLayout } from './LoginPage';

export const SignUpPage: React.FC = () => (
  <AuthLayout>
    <SignUpForm />
  </AuthLayout>
);
